import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({ selector: '[oscNumbersOnly]' })
export class NumbersOnlyDirective {
    private allowedKeys = [
        'Backspace',
        'Delete',
        'Tab',
        'Escape',
        'Enter',
        'Clear',
        'Copy',
        'Paste',
        'Home',
        'End',
        'ArrowLeft',
        'ArrowRight',
        'NumLock',
        'Insert',
    ];

    private inputEl: HTMLInputElement;

    private regexCheckOnlyNumerical = new RegExp(/^\d+$/g);
    private regexDetectNonNumeric = new RegExp(/[^0-9]/g);

    public constructor(public element: ElementRef) {
        this.inputEl = element.nativeElement;
        this.inputEl.inputMode = 'numeric';
        this.inputEl.pattern = '[0–9]*';
        this.inputEl.step = '1';
    }

    /**
     * Handle all keypresses on the host element.
     */
    @HostListener('keydown', ['$event'])
    public keydown(event: KeyboardEvent): void {
        // Following <ctrl>-actions are allowed
        if (
            this.allowedKeys.indexOf(event.key) > -1 || // navigation keys: backspace, delete, arrows etc.
            ((event.ctrlKey || event.metaKey) && event.key === 'a') || // ctrl + a or mac: cmd + a
            ((event.ctrlKey || event.metaKey) && event.key === 'c') || // ctrl + c or mac: cmd + c
            ((event.ctrlKey || event.metaKey) && event.key === 'v') || // ctrl + v or mac: cmd + v
            ((event.ctrlKey || event.metaKey) && event.key === 'x') // ctrl + x or mac: cmd + x
        ) {
            return;
        }

        if (!String(event.key).match(this.regexCheckOnlyNumerical)) {
            event.preventDefault();
        }
    }

    /**
     * Handle drag & drop, as illigal characters could be entered this way.
     */
    @HostListener('drop', ['$event'])
    public drop(event: DragEvent): void {
        this.setSanitizedValueAndPreventDefault(event, event.dataTransfer?.getData('text'));
    }

    /**
     * Handle paste, as illigal characters could be entered this way.
     */
    @HostListener('paste', ['$event'])
    public paste(event: ClipboardEvent): void {
        this.setSanitizedValueAndPreventDefault(event, event.clipboardData?.getData('text/plain'));
    }

    private setSanitizedValueAndPreventDefault(event: Event, value?: string) {
        this.inputEl.value = value?.replace(this.regexDetectNonNumeric, '') ?? '';
        event.preventDefault();
    }
}
